/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './PersonalizationPublicRpc';
import * as Queries from './PersonalizationPublicRpc.dfc.new';
import type { AdditionalContextArgs } from './PersonalizationPublicRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseSearchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'search', References.SearchResponseType>
        : References.SearchResponseType)
    | undefined;
};

export function useSearchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.SEARCH_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            search: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseSearchQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseSearchQueryReturn<T>;
}

type UseSearchLazyQueryReturn<T extends boolean> = LazyQueryResultTupleOverride<
  Record<'result', References.SearchResponseType>,
  References.SearchRequestType,
  T extends true
    ? Record<'search', References.SearchResponseType>
    : References.SearchResponseType
>;

export function useSearchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEARCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            search: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSearchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSearchLazyQueryReturn<T>;
}

type UseSearchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'search', References.SearchResponseType>
    : References.SearchResponseType;
};

export function useSearchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.SEARCH_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            search: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchSuspenseQueryReturn<T>;
}

type UseAutocompleteQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.AutocompleteResponseType>,
    References.AutocompleteRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'autocomplete', References.AutocompleteResponseType>
        : References.AutocompleteResponseType)
    | undefined;
};

export function useAutocompleteQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.AutocompleteResponseType>,
    References.AutocompleteRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAutocompleteQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.AUTOCOMPLETE_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            autocomplete: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseAutocompleteQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseAutocompleteQueryReturn<T>;
}

type UseAutocompleteLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.AutocompleteResponseType>,
    References.AutocompleteRequestType,
    T extends true
      ? Record<'autocomplete', References.AutocompleteResponseType>
      : References.AutocompleteResponseType
  >;

export function useAutocompleteLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.AutocompleteResponseType>,
    References.AutocompleteRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAutocompleteLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.AUTOCOMPLETE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            autocomplete: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseAutocompleteLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseAutocompleteLazyQueryReturn<T>;
}

type UseAutocompleteSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.AutocompleteResponseType>,
    References.AutocompleteRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'autocomplete', References.AutocompleteResponseType>
    : References.AutocompleteResponseType;
};

export function useAutocompleteSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.AutocompleteResponseType>,
    References.AutocompleteRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAutocompleteSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.AUTOCOMPLETE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            autocomplete: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseAutocompleteSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseAutocompleteSuspenseQueryReturn<T>;
}

type UseGetSuggestionSectionsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSuggestionSectionsResponseType>,
    References.GetSuggestionSectionsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSuggestionSections',
            References.GetSuggestionSectionsResponseType
          >
        : References.GetSuggestionSectionsResponseType)
    | undefined;
};

export function useGetSuggestionSectionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSuggestionSectionsResponseType>,
    References.GetSuggestionSectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestionSectionsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SUGGESTION_SECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSuggestionSections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSuggestionSectionsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSuggestionSectionsQueryReturn<T>;
}

type UseGetSuggestionSectionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSuggestionSectionsResponseType>,
    References.GetSuggestionSectionsRequestType,
    T extends true
      ? Record<
          'getSuggestionSections',
          References.GetSuggestionSectionsResponseType
        >
      : References.GetSuggestionSectionsResponseType
  >;

export function useGetSuggestionSectionsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSuggestionSectionsResponseType>,
    References.GetSuggestionSectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestionSectionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SUGGESTION_SECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSuggestionSections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSuggestionSectionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSuggestionSectionsLazyQueryReturn<T>;
}

type UseGetSuggestionSectionsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSuggestionSectionsResponseType>,
    References.GetSuggestionSectionsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getSuggestionSections',
        References.GetSuggestionSectionsResponseType
      >
    : References.GetSuggestionSectionsResponseType;
};

export function useGetSuggestionSectionsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSuggestionSectionsResponseType>,
    References.GetSuggestionSectionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestionSectionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SUGGESTION_SECTIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSuggestionSections: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSuggestionSectionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSuggestionSectionsSuspenseQueryReturn<T>;
}

type UseGetSuggestionSectionsByTypeQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSuggestionSectionsByTypeResponseType>,
    References.GetSuggestionSectionsByTypeRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSuggestionSectionsByType',
            References.GetSuggestionSectionsByTypeResponseType
          >
        : References.GetSuggestionSectionsByTypeResponseType)
    | undefined;
};

export function useGetSuggestionSectionsByTypeQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSuggestionSectionsByTypeResponseType>,
    References.GetSuggestionSectionsByTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestionSectionsByTypeQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSuggestionSectionsByType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSuggestionSectionsByTypeQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSuggestionSectionsByTypeQueryReturn<T>;
}

type UseGetSuggestionSectionsByTypeLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSuggestionSectionsByTypeResponseType>,
    References.GetSuggestionSectionsByTypeRequestType,
    T extends true
      ? Record<
          'getSuggestionSectionsByType',
          References.GetSuggestionSectionsByTypeResponseType
        >
      : References.GetSuggestionSectionsByTypeResponseType
  >;

export function useGetSuggestionSectionsByTypeLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSuggestionSectionsByTypeResponseType>,
    References.GetSuggestionSectionsByTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestionSectionsByTypeLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSuggestionSectionsByType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSuggestionSectionsByTypeLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSuggestionSectionsByTypeLazyQueryReturn<T>;
}

type UseGetSuggestionSectionsByTypeSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetSuggestionSectionsByTypeResponseType>,
      References.GetSuggestionSectionsByTypeRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getSuggestionSectionsByType',
          References.GetSuggestionSectionsByTypeResponseType
        >
      : References.GetSuggestionSectionsByTypeResponseType;
  };

export function useGetSuggestionSectionsByTypeSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSuggestionSectionsByTypeResponseType>,
    References.GetSuggestionSectionsByTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestionSectionsByTypeSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSuggestionSectionsByType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSuggestionSectionsByTypeSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSuggestionSectionsByTypeSuspenseQueryReturn<T>;
}

type UseSearchAssetsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SearchAssetsResponseType>,
    References.SearchAssetsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'searchAssets', References.SearchAssetsResponseType>
        : References.SearchAssetsResponseType)
    | undefined;
};

export function useSearchAssetsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SearchAssetsResponseType>,
    References.SearchAssetsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchAssetsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.SEARCH_ASSETS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchAssets: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseSearchAssetsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseSearchAssetsQueryReturn<T>;
}

type UseSearchAssetsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.SearchAssetsResponseType>,
    References.SearchAssetsRequestType,
    T extends true
      ? Record<'searchAssets', References.SearchAssetsResponseType>
      : References.SearchAssetsResponseType
  >;

export function useSearchAssetsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SearchAssetsResponseType>,
    References.SearchAssetsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchAssetsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEARCH_ASSETS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchAssets: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSearchAssetsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSearchAssetsLazyQueryReturn<T>;
}

type UseSearchAssetsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SearchAssetsResponseType>,
    References.SearchAssetsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'searchAssets', References.SearchAssetsResponseType>
    : References.SearchAssetsResponseType;
};

export function useSearchAssetsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SearchAssetsResponseType>,
    References.SearchAssetsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchAssetsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.SEARCH_ASSETS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            searchAssets: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchAssetsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchAssetsSuspenseQueryReturn<T>;
}
